import { Component, OnInit } from '@angular/core';
import { DeviceType } from '@interfaces/common.interface';
import { NavigationService } from '@app/services/navigation.service';
import { Nft } from '@interfaces/api.nft.interface';
import { MembershipItem } from '@interfaces/membership.interface';
import { ModalComponent } from '../../../common/modal/modal.component';

@Component({
  selector: 'ark-nft-confirm',
  templateUrl: './nft-confirm.component.html',
  styleUrls: ['./nft-confirm.component.scss'],
})
export class NftConfirmComponent implements OnInit {
  nft!: Nft;
  membership!: MembershipItem;
  device: DeviceType = 'desktop';

  constructor(
    protected readonly parent: ModalComponent,
    private navigation: NavigationService,
  ) {}

  ngOnInit(): void {
    this.nft = this.parent.data.nft;
    this.membership = this.parent.data.membership;
  }

  ngAfterViewInit() {
    this.device = this.navigation.getTargetDevice();
  }

  close(confirm = false): void {
    this.parent.close(confirm);
  }

  gotoStripe(): void {
    window.open('https://stripe.com', '_blank');
  }
}
